import {useMemo, createContext} from 'react';
import PropTypes from 'prop-types';
import {FmlxTooltip} from 'fmlx-common-ui';
import './PipettingProfileItem.scss';

export const PipettingProfileContext = createContext(null);

export function PipettingProfileWrapper({aspirateTask, dispenseTask, children}) {
  const value = useMemo(() => ({aspirateTask, dispenseTask}), [aspirateTask, dispenseTask]);

  return (
    <PipettingProfileContext.Provider value={value}>
      <div className="pipetting-profile-wrapper">{children}</div>
    </PipettingProfileContext.Provider>
  );
}

PipettingProfileWrapper.propTypes = {
  aspirateTask: PropTypes.object,
  dispenseTask: PropTypes.object,
  children: PropTypes.any,
};

PipettingProfileWrapper.defaultProps = {
  aspirateTask: null,
  dispenseTask: null,
  // eslint-disable-next-line react/jsx-no-useless-fragment
  children: <></>,
};

export function PipettingProfileItemWrapper({toolTipLabel, children, className}) {
  return (
    <FmlxTooltip title={toolTipLabel}>
      <div className={`pipetting-profile__item${className ? ` ${className}` : ''}`}>{children}</div>
    </FmlxTooltip>
  );
}

PipettingProfileItemWrapper.propTypes = {
  toolTipLabel: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
};

PipettingProfileItemWrapper.defaultProps = {
  toolTipLabel: '',
  // eslint-disable-next-line react/jsx-no-useless-fragment
  children: <></>,
  className: '',
};

export default PipettingProfileWrapper;
